import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import { MdAutorenew } from "react-icons/md";
import { truncateText } from "../../helpers";
import { FaFileAlt } from "react-icons/fa";
import Tooltip from "../Tooltip";
import TenantMiniProfile from "../Common/TenantMiniProfile";

const Table = ({
  apiData,
  setSelectedData,
  setIsRenewAgreement,
  setIsViewNotes,
}) => {
  const storageKey = `tenant_expiring_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);

  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const renewAgreement = (item) => {
    setIsRenewAgreement(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const notes = (item) => {
    setIsViewNotes(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      <Tooltip label="Click to view and add notes">
        {/* <button
          onClick={(e) => {
            e.stopPropagation();
            notes(item);
          }}
          className="text-gray-400 hover:text-blue-600 transition"
        >
          <FaFileAlt size={16} />
        </button> */}
      </Tooltip>
      <Tooltip label="View tenant details">
        <button
          onClick={() => goToDues("Tenant Info", item)}
          className="text-gray-400 hover:text-gray-700 transition"
        >
          <MdOutlineChevronRight size={22} />
        </button>
      </Tooltip>
    </div>
  );


  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        rent: <span class="text-gray-600 text-sm flex">{'₹' + item.rent}</span>,
        dues: getDues(item),
        roomNum: getBedsFloors(item),
        expiryDate: item.agreementExpiry ? showExpiryData(item) : '-',
        moveInOutDate: moveInOutDate(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return <TenantMiniProfile
      tenantId={item.tenantId}
      name={item.tenantName}
      mobile={item.tenantMobile}
      profilePicture={item.profilePicture}
      kycStatus={item.kycStatus}
      flatName={`${item.flatNo}, ${item.inventoryName}`}
    />
  };

  const goToDues = (clickOn, item) => {
    navigate(`/tenant/${item.tenantId}`, {
      state: {
        tabName: clickOn,
        tabKey: "totalDues",
      },
    });
  };

  const getDues = (item) => {
    if (Number(item?.totalDues) === 0) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      );
    }

    return <Amount>₹{item?.totalDues}</Amount>;
  };

  const showExpiryData = (item) => {
    const daysLeft = moment(item.agreementExpiry).diff(moment(), "days");

    const urgencyStyle =
      daysLeft <= 15
        ? "bg-red-50 text-red-700"
        : daysLeft <= 30
          ? "bg-amber-50 text-amber-700"
          : "bg-slate-100 text-gray-700";

    return (
      <div className="flex items-center gap-2">
        <span
          className={`${urgencyStyle} px-3 py-1 rounded-full text-sm font-medium`}
        >
          {moment(item.agreementExpiry).format("DD, MMM YYYY")}
        </span>

        <button
          onClick={() => renewAgreement(item)}
          title="Renew Agreement"
          className="text-gray-500 hover:text-gray-800 transition"
        >
          <MdAutorenew size={18} />
        </button>
      </div>
    );
  };

  const getBedsFloors = (item) => (
    <span
      className="text-sm text-gray-600 truncate cursor-pointer"
      title={item.inventoryName}
      onClick={() => goToDues("Tenant Info", item)}
    >
      {truncateText(item.inventoryName, 28)}
    </span>
  );

  const moveInOutDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span>
            {item.moveInDate
              ? moment(item.moveInDate).format("DD, MMM YY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">M.In Date</span>
        </div>
        <div className="flex flex-col">
          <span>
            {item.agreementExpiry
              ? moment(item.agreementExpiry).format("DD, MMM YY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">Expiry Date</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "roomNum",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Inventory",
        accessor: "roomNum",
      },
      {
        Header: "Rent",
        accessor: "rent",
      },
      {
        Header: "Dues",
        accessor: "dues",
      },
      {
        Header: "Expiry Date",
        accessor: "expiryDate",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}

    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`text-sm font-medium text-rose-700 bg-rose-100 px-3 py-1 rounded-full cursor-default hover:bg-rose-200 transition inline-flex`

export default Table;
